/** @deprecated use enum IdentifierTypeScope instead */
export const IDENTIFIER_SCOPES = {
    PERSON: 'PERSON',
    CENTER_PATIENT: 'CENTER_PATIENT',
    REQUEST: 'REQUEST',
    CASE: 'CASE',
    SUBREQUEST: 'SUBREQUEST',
    SAMPLE: 'SAMPLE',
    PORTION: 'PORTION',
    SUBPORTION: 'SUBPORTION',
    INCIDENT: 'INCIDENT',
    SHIPMENT: 'SHIPMENT',
    DELIVERY_NOTES: 'DELIVERY_NOTES',
    INVOICE: 'INVOICE'
}

export const PATIENT_IDENTIFIER = 'PATIENT'
export const INSURANCE_NUMBER = 'INSURANCE_NUMBER'
